import React from "react";
import { Tooltip } from "react-tooltip";

import "./tooltip.scss";

function TooltipReact({ children, id, content, click = false }) {
  return (
    <>
      <a
        data-tooltip-id={`tooltip-${id}`}
        data-tooltip-html={`<div class="tooltipReact">${content}</div>`}
        data-tooltip-place="top-end"
      >
        {children}
      </a>
      <Tooltip id={`tooltip-${id}`} events={click ? ["click"] : ["hover"]} />
    </>
  );
}

export default TooltipReact;
